/** Dashboard widgets: labels and small formatters (pure, no React). */
const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
const WEEKDAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export const HOLIDAY_TYPE = {
  REGULAR: { label: "Regular holiday", tone: "red" },
  SPECIAL_NON_WORKING: { label: "Special non-working", tone: "amber" },
  SPECIAL_WORKING: { label: "Special working", tone: "blue" },
  COMPANY: { label: "Company holiday", tone: "purple" },
};

export const HOLIDAY_SCOPE = {
  NATIONAL: "National",
  COMPANY: "Company",
  BRANCH: "Branch",
};

/** 0 → "Today", 1 → "Tomorrow", n → "In n days", negative → "n days ago". */
export const daysAwayText = (n) => {
  const d = Number(n);
  if (!Number.isFinite(d)) return "";
  if (d === 0) return "Today";
  if (d === 1) return "Tomorrow";
  if (d === -1) return "Yesterday";
  return d > 0 ? `In ${d} days` : `${-d} days ago`;
};

/** "YYYY-MM-DD" → { month: "Oct", day: "30", weekday: "Fri" } for the date badge. */
export const dateBadge = (ymd) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(ymd || "");
  if (!m) return { month: "", day: "", weekday: "" };
  // Calendar date only: UTC keeps the weekday right in every timezone
  const d = new Date(Date.UTC(+m[1], +m[2] - 1, +m[3]));
  return {
    month: MONTHS[d.getUTCMonth()],
    day: String(d.getUTCDate()),
    weekday: WEEKDAYS[d.getUTCDay()],
  };
};

export const initialsOf = (name = "") =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();

/** "YYYY-MM-DD" → "Fri, Oct 31". */
export const shortDate = (ymd) => {
  const b = dateBadge(ymd);
  return b.day ? `${b.weekday}, ${b.month} ${b.day}` : "";
};

/**
 * Birthdays → { today, thisWeek (next 6 days), later } (each keeps the
 * server order: daysAway, then name).
 */
export const groupBirthdays = (items = []) => ({
  today: (items || []).filter((b) => b.daysAway === 0),
  thisWeek: (items || []).filter((b) => b.daysAway > 0 && b.daysAway <= 6),
  later: (items || []).filter((b) => b.daysAway > 6),
});

/** Where a birthday row leads: my profile, the HR profile, or nowhere (hover card). */
export const birthdayLink = (b) => {
  if (b?.isMe) return "/me/profile";
  if (b?.canViewProfile && b.employeeId) return `/employee/${b.employeeId}`;
  return null;
};

/** Holiday badge: Branch for branch-only holidays, else the type. */
export const holidayBadge = (h) => {
  if (h?.scope === "BRANCH") return { label: "Branch", tone: "blue" };
  const t = {
    REGULAR: { label: "Regular", tone: "red" },
    SPECIAL_NON_WORKING: { label: "Special", tone: "amber" },
    SPECIAL_WORKING: { label: "Special working", tone: "blue" },
    COMPANY: { label: "Company", tone: "purple" },
  }[h?.type];
  return t || { label: h?.type || "Holiday", tone: "gray" };
};
